
// 远程同步状态枚举
export enum RemoteSyncStatus {
    Synced = 'synced',      // 已同步
    Pending = 'pending',    // 待同步（本地有更改未同步到服务器）
    Failed = 'failed',      // 同步失败
}

// IProject的一些本地杂项设置
export interface IProjectSettings {
    syncToServer: boolean; // 默认false，保存时仅保存到本地，不上传到服务器。在勾选这个选项时需要明确告知用户，勾选了上传到服务器，并选择了public后就会让所有人看到这个project并且可以fork这个project，所以隐私信息不要放在project里。

    // 远程同步状态（仅当 syncToServer=true 时有意义）
    // undefined: 从未同步过（初始状态）
    remoteSyncStatus?: RemoteSyncStatus;

    // 最后同步时间（毫秒时间戳）
    lastSyncTime?: number;
}

export function createDefaultProjectSettings(): IProjectSettings {
    return {
        syncToServer: false,
        // remoteSyncStatus 不设置，表示从未同步
        // lastSyncTime 不设置
    };
}
